import Vue from 'vue';
import VueResource from 'vue-resource';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

export default {
  relatorioLancamentos: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioLancamentos`)
      .then(response => response.data);
  },
  relatorioLancamentosTodosProjetos: (dataInicio, dataFim) => {
    return Vue.http.get('/api/transparencia/RelatorioLancamentosTodosProjetos', {
      params: {
        dataInicio,
        dataFim
      }
    }).then(response => response.data);
  },
  relatorioPagamentoPessoaFisica: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioPagamentoPessoaFisica`)
      .then(response => response.data);
  },
  relatorioPagamentoAgente: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioPagamentoAgente`)
      .then(response => response.data);
  },
  relatorioPagamentoAluno: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioPagamentoAluno`)
      .then(response => response.data);
  },
  relatorioPagamentoClt: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioPagamentoClt`)
      .then(response => response.data);
  },
  relatorioPagamentoPessoaJuridica: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioPagamentoPessoaJuridica`)
      .then(response => response.data);
  },
  relatorioRubricas: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioRubricas`)
      .then(response => response.data);
  },
  relatorioComprasLicitacoes: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioComprasLicitacoes`)
      .then(response => response.data);
  },
  relatorioItensComprasLicitacoes: (idProjeto, idPedidoCompra) => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioItensComprasLicitacoes/${idPedidoCompra}`)
      .then(response => response.data);
  },
  relatorioAcompanhamentoProjeto: id => {
    return Vue.http.get(`/api/transparencia/${id}/RelatorioAcompanhamentoProjeto`)
      .then(response => response.data);
  },
  relatorioTransparencia: (pagina, idCoordenador, idOrgaoFinanciador, tituloProjeto, dataInicio, dataFim, objetivo, numeroConvenio, numeroProcesso, idMaisFiltros, idTipoOrgao, emendaParlamentar) => {
    return Vue.http.get('/api/transparencia/RelatorioTransparencia', {
      params: {
        pagina,
        idCoordenador,
        idOrgaoFinanciador,
        tituloProjeto,
        dataInicio,
        dataFim,
        objetivo,
        numeroConvenio,
        numeroProcesso,
        idMaisFiltros,
        idTipoOrgao,
        emendaParlamentar
      }
    })
      .then(response => response.data);
  },
  coordenadores: () => {
    return Vue.http.get('/api/transparencia/coordenadores')
      .then(response => response.data);
  },
  orgaosFinaciadores: () => {
    return Vue.http.get('/api/transparencia/OrgaosFinaciadores')
      .then(response => response.data);
  },
  orgaosFinaciadoresProjeto: id => {
    return Vue.http.get(`/api/transparencia/${id}/OrgaosFinaciadores`)
      .then(response => response.data);
  },
  informacaoProjeto: id => {
    return Vue.http.get(`/api/transparencia/${id}/InformacaoTransparencia`)
      .then(response => response.data);
  },
  informacoesInstitucionais: () => {
    return Vue.http.get('/api/transparencia/InformacoesInstitucionais')
      .then(response => response.data);

  },
  detalhesInformacaoInstitucional: id => {
    return Vue.http.get(`/api/transparencia/${id}/DetalhesInformacaoInstitucional`)
      .then(response => response.data);
  },
  institucionalPagamentos: (filtro, tipoFiltro, dataInicio, dataFim) => {
    return Vue.http.get('/api/transparencia/InstitucionalPagamentos', {
      params: {
        filtro,
        tipoFiltro,
        dataInicio,
        dataFim
      }})
      .then(response => response.data
    );
  },
  arquivos: id => {
    return Vue.http.get(`/api/transparencia/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/transparencia/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  arquivosAcompanhamentoProjeto: idAcompanhamentoProjeto => {
    return Vue.http.get(`/api/transparencia/${idAcompanhamentoProjeto}/arquivosacompanhamentoprojeto`)
      .then(response => response.data);
  },
  downloadAcompanhamentoProjeto: (idAcompanhamentoProjeto, arquivo) => {
    return Vue.http.get(`/api/transparencia/${idAcompanhamentoProjeto}/downloadarquivoacompanhamentoprojeto/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  arquivosInstitucional: idInstitucional => {
    return Vue.http.get(`/api/transparencia/${idInstitucional}/arquivosinstitucional`)
      .then(response => response.data);
  },
  downloadInstitucional: (idInstitucional, arquivo) => {
    return Vue.http.get(`/api/transparencia/${idInstitucional}/downloadarquivoinstitucional/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/transparencia/servico.js